import { Input, Select, Switch, Tabs } from '@mantine/core';
import Header from 'components/Header';
import React, { useState } from 'react';

import { ReactComponent as SearchIcon } from 'assets/icons/searchIcon.svg';
import { ReactComponent as FilterIcon } from 'assets/icons/filterIcon.svg';
import { ReactComponent as DownArrowIcon } from 'assets/icons/downArrow.svg';
import PrimaryButton from 'components/primaryButton';
import StoriesForReview from './components/Storiesforreview';
import AddNewStroryModal from './components/addnewstrorymodal';
import dayjs from 'dayjs';

import Usegetblogs from './hooks/usegetblogdata';
import PublishedStories from './components/publishedstories';
import DeletedStories from './components/deletedstories';
import MyStoriesAdmin from './components/mystoriesadmin';

export default function Blogs() {
  const [activeTab, setActiveTab] = useState(0);
  const [newStoryModal, setNewStoryModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [isDraft, setIsDraft] = useState(false);
  const [filterValue, setFilterValue] = useState('');

  const blogData = Usegetblogs({});

  //  filtering the years for created stories
  const dates = blogData?.data?.data?.map((story) =>
    dayjs(story.created_date).format('YYYY')
  );

  var years = [];

  if (dates) {
    dates.forEach((date) => {
      if (years.indexOf(date) === -1) {
        years.push(date);
      }
    });
  }
  console.log('years', years);

  if (years.length === 0) {
    years.push({
      value: 'no data',
      label: 'No data',
      disabled: true,
    });
  } else {
    years = years.sort();
  }

  return (
    <React.Fragment>
      <div className='px-5'>
        <div className='flex justify-between items-center mt-6'>
          <p className='text-xl text-A8A8A8'>
            {/* Calendar &#60;{' '}
            <span className='text-gray font-semibold'> Leaves & Holidays</span> */}
            Submit a story
          </p>
          <Header />
        </div>
        <div className='mt-8'>
          <div className='mt-8 relative'>
            <div>
              <Tabs
                tabPadding={21}
                onTabChange={setActiveTab}
                classNames={{
                  tabsListWrapper: 'border-0',
                  tabActive: 'border-2 border-primary font-semibold text-18',
                  tabControl: 'text-A8A8A8 leading-5 px-0 mr-4',
                  tabLabel: 'text-18 text-gray',
                }}
              >
                <Tabs.Tab label='Stories for review'>
                  <StoriesForReview
                    searchText={searchText}
                    filterValue={filterValue}
                  />
                </Tabs.Tab>
                <Tabs.Tab label='Published'>
                  <PublishedStories
                    searchText={searchText}
                    filterValue={filterValue}
                  />
                </Tabs.Tab>
                <Tabs.Tab label='My stories'>
                  <MyStoriesAdmin
                    isDraft={isDraft}
                    searchText={searchText}
                    filterValue={filterValue}
                  />
                </Tabs.Tab>
                <Tabs.Tab label='Deleted stories'>
                  <DeletedStories
                    searchText={searchText}
                    filterValue={filterValue}
                  />
                </Tabs.Tab>
              </Tabs>
            </div>
            {/* Search  */}
            <div className='absolute top-2 right-0 flex items-center gap-3'>
              <Input
                icon={<SearchIcon />}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder='Search'
                classNames={{
                  wrapper: 'border-primary border-b',
                  input: 'w-48  bg-light-bg border-none',
                }}
              />
              <Select
                data={years}
                value={filterValue}
                onChange={setFilterValue}
                icon={<FilterIcon />}
                clearable
                rightSection={<DownArrowIcon />}
                className='w-40'
                classNames={{
                  rightSection: 'pointer-events-none',
                  wrapper: 'border-primary border-b',
                  input: '  bg-light-bg border-none',
                }}
              />
              {activeTab === 2 ? (
                <React.Fragment>
                  <p>Active</p>
                  <Switch
                    onChange={() => setIsDraft(!isDraft)}
                    checked={isDraft}
                  />
                  <p>Draft</p>
                </React.Fragment>
              ) : null}
              {blogData?.data?.data.length === 0 ? null : (
                <button onClick={() => setNewStoryModal(true)}>
                  <PrimaryButton>Add a story</PrimaryButton>
                </button>
              )}
            </div>
          </div>{' '}
        </div>
      </div>
      <AddNewStroryModal
        setNewStoryModal={setNewStoryModal}
        newStoryModal={newStoryModal}
      />
    </React.Fragment>
  );
}
